
import { Injectable } from '@angular/core';
import { Headers, Http, Response } from '@angular/http';
import { Observable } from "rxjs/Observable";



import {
    CanadaPostAddress_CreateAccount, CanadaPostAddress_BillingAddress, CanadaPostAddress_ShippingAddress, CanadaPostAddress_CheckoutBillingShipping
} from './canadapostaddress.service';
import { PowerReviews_ReadReview } from './powerreviews.service';
import { PayPal_Payment } from './paypal.service';



export class ExternalAPI {

    private _http: Http

    constructor(private http: Http) {
        this._http = http;
    }

    //CanadaPost Address Autocomplete
    get canadapost_CreateAccount(): CanadaPostAddress_CreateAccount {
        return new CanadaPostAddress_CreateAccount(this._http);
    }
    get canadapost_BillingAddress(): CanadaPostAddress_BillingAddress {
        return new CanadaPostAddress_BillingAddress(this._http);
    }
    get canadapost_ShippingAddress(): CanadaPostAddress_ShippingAddress {
        return new CanadaPostAddress_ShippingAddress(this._http);
    }
    get canadapost_CheckoutBillingShippingAddress(): CanadaPostAddress_CheckoutBillingShipping {
        return new CanadaPostAddress_CheckoutBillingShipping(this._http);
    }

    //Paypal
    get paypal_Payment(): PayPal_Payment {
        return new PayPal_Payment(this._http);
    }

    get powerreview_ReadReview(): PowerReviews_ReadReview {
        return new PowerReviews_ReadReview(this._http);
    }
static ctorParameters() { return [ { type: Http } ]; }}



// WEBPACK FOOTER //
// C:/AzureDevOpsAgent/_work/3/s/TSC.Web.WebFactory/node_modules/ngc-webpack??ref--0-1!C:/AzureDevOpsAgent/_work/3/s/TSC.Web.WebFactory/node_modules/angular2-template-loader!../external_api/service/external-api.service.ts